<a href="" (click)="false;" class="sg-icon-nav__toggle" [ngClass]="{'sg-icon-nav__toggle--hidden': !hidden}" (click)="toggleNav()">
    <mlp-ng-icon name="{{ openIcon.name }}"></mlp-ng-icon>
</a>

<nav class="sg-icon-nav__menu" [@fadeAnimation]="hidden">
    <a href="" (click)="false;" *ngIf="!hidden" class="sg-icon-nav__toggle sg-icon-nav__toggle--open" (click)="toggleNav()">
        <mlp-ng-icon size="small" name="{{ closeIcon.name }}"></mlp-ng-icon>
    </a>

    <ng-content></ng-content>

    <ng-container *ngFor="let link of links">
        <a *ngIf="link.routerLink" [routerLink]="link.routerLink" class="sg-icon-nav__link" >{{ link.name }}</a>
        <a *ngIf="link.href" [href]="link.href" class="sg-icon-nav__link" >{{ link.name }}</a>
    </ng-container>
</nav>

